import request from "@/utils/request";

export function getRelationships() {
  return request({
    url: "/relationships",
    method: "get",
  });
}

export function getRelationship(id) {
  return request({
    url: `/relationships/${id}`,
    method: "get",
  });
}

export function createRelationship(data) {
  return request({
    url: "/relationships",
    method: "post",
    data,
  });
}

export function updateRelationship(id, data) {
  return request({
    url: `/relationships/${id}`,
    method: "put",
    data,
  });
}

export function deleteRelationship(id) {
  return request({
    url: `/relationships/${id}`,
    method: "delete",
  });
}

// Funções auxiliares para filtrar por tipo
export function getInternalEmployees(companyId) {
  return request({
    url: "/relationships",
    method: "get",
    params: {
      relationshipType: "internal",
      company: companyId,
    },
  });
}

export function getThirdParties(companyId) {
  return request({
    url: "/relationships",
    method: "get",
    params: {
      relationshipType: "third-party",
      company: companyId,
    },
  });
}

export function searchRelationships(searchTerm, companyId = null) {
  const params = {
    search: searchTerm,
  };

  if (companyId !== null && companyId !== undefined) {
    params.company = companyId;
  }

  return request({
    url: "/relationships",
    method: "get",
    params,
  });
}
